import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="564"
      height="400"
      fill="none"
      viewBox="0 0 564 400"
    >
      <path
        fill="#DADADA"
        d="M75.275 317.36s-5.368 29.294 31.292 42.528c0 0 4.268.988 1.714-4.846-2.553-5.846-23.449.295-30.111-32.643 0 0-.307-7.604-2.895-5.039zM88.407 315.214s-3.7 20.226 21.611 29.374c0 0 2.951.681 1.18-3.348-1.759-4.03-16.185.204-20.793-22.541 0 0-.205-5.255-1.998-3.485z"
        opacity="0.23"
      ></path>
      <path
        fill="#fff"
        d="M292.878 190.364H104.434c-4.79 0-8.717-3.915-8.717-8.716V64.845c0-4.79 3.915-8.717 8.717-8.717h188.444c4.789 0 8.716 3.916 8.716 8.717v116.803c0 4.801-3.915 8.716-8.716 8.716z"
      ></path>
      <path
        fill="#5673FF"
        d="M131.946 131.662h-10.328a2.882 2.882 0 01-2.872-2.871v-10.329a2.882 2.882 0 012.872-2.871h10.328a2.882 2.882 0 012.872 2.871v10.329a2.882 2.882 0 01-2.872 2.871z"
        opacity="0.37"
      ></path>
      <path
        stroke="#4E4F57"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M127.611 127.645h-12.724a2.882 2.882 0 01-2.871-2.871V112.05a2.882 2.882 0 012.871-2.871h12.724a2.882 2.882 0 012.871 2.871v12.724a2.882 2.882 0 01-2.871 2.871z"
      ></path>
      <path
        fill="#5673FF"
        d="M186.052 131.662h-10.329a2.88 2.88 0 01-2.871-2.871v-10.329a2.881 2.881 0 012.871-2.871h10.329a2.882 2.882 0 012.871 2.871v10.329a2.881 2.881 0 01-2.871 2.871zM239.931 131.662h-10.329a2.882 2.882 0 01-2.872-2.871v-10.329a2.882 2.882 0 012.872-2.871h10.329a2.882 2.882 0 012.871 2.871v10.329a2.881 2.881 0 01-2.871 2.871z"
        opacity="0.37"
      ></path>
      <path
        stroke="#4E4F57"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M181.716 127.645h-12.723a2.882 2.882 0 01-2.872-2.871V112.05a2.882 2.882 0 012.872-2.871h12.723a2.882 2.882 0 012.872 2.871v12.724a2.882 2.882 0 01-2.872 2.871zM235.595 127.645h-12.723a2.882 2.882 0 01-2.872-2.871V112.05a2.882 2.882 0 012.872-2.871h12.723a2.881 2.881 0 012.871 2.871v12.724a2.881 2.881 0 01-2.871 2.871z"
      ></path>
      <g stroke="#0A0B1F" strokeMiterlimit="10" opacity="0.45">
        <path d="M113.15 150.424h2.838"></path>
        <path strokeDasharray="5.25 5.25" d="M121.946 150.424h80.438"></path>
        <path d="M205.369 150.424h2.838"></path>
      </g>
      <path
        stroke="#5673FF"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M222.825 184.69H94.775c-5.755 0-10.42-4.665-10.42-10.42v-14.369M84.356 114.32V42.19c0-.056.079-.08.102-.022.85 2.417 4.835 14.267 10.317 14.267h191.418c5.754 0 10.419 4.664 10.419 10.419v46.558"
      ></path>
      <path
        fill="#5673FF"
        d="M296.6 83.675H84.355v-42.62c0-.056.08-.079.103-.022.85 2.417 4.835 14.267 10.317 14.267h191.418c5.754 0 10.419 4.665 10.419 10.42v17.955h-.012z"
      ></path>
      <path
        fill="#FA0"
        d="M148.72 72.325a5.107 5.107 0 100-10.214 5.107 5.107 0 000 10.214z"
      ></path>
      <path
        fill="#fff"
        d="M126.02 72.325a5.108 5.108 0 10-.001-10.215 5.108 5.108 0 00.001 10.215zM101.049 72.325a5.107 5.107 0 100-10.214 5.107 5.107 0 000 10.214z"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M458.796 121.988l-7.02-25.409a.792.792 0 00-1.432-.234l-6.847 9.239-10.214 5.374c-.63.281-.614 1.184.031 1.449l24.396 10.516a.803.803 0 001.086-.935zM458.82 122.984l-15-17"
      ></path>
      <g
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        opacity="0.41"
      >
        <path d="M442.149 103.223s-.535-.692-1.525-1.792"></path>
        <path
          strokeDasharray="3.05 3.05"
          d="M437.196 98.098c-7.028-6.21-20.989-14.904-38.471-7.107-16.744 7.468-26.664 4.45-31.491 1.51"
        ></path>
        <path d="M365.27 91.118c-1.148-.944-1.682-1.651-1.682-1.651"></path>
      </g>
      <path
        fill="#13CB75"
        stroke="#28282D"
        strokeMiterlimit="10"
        d="M318.906 191.924s-49.418 8.467-54.049 22.564l15.107-40.485s-2.815-4.835-2.622-7.65c.193-2.815-8.251-6.038-9.67-6.038-1.407 0-15.311-.602-18.126-18.331 0 0-26.99 34.436-24.572 82.572 2.417 48.135 57.794 27.591 57.794 27.591l3.166-18.375L273.552 338.6H378.38l-12.689-103.466 9.364 65.705s17.365 29.601 38.964 7.094c0 0 13.745-9.512 1.203-52.415l-6.061-20.282a28.74 28.74 0 00-8.433-13.257c-10.862-9.647-33.868-28.205-51.688-29.544l-15.583 23.336-14.551-23.847z"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M219.193 338.606h218.408"
      ></path>
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M333.408 217.639v46.364"
      ></path>
      <path
        fill="#010048"
        d="M314.17 159.413s5.925 1.816 6.923-10.476c0 0 11.668.749 20.34-3.348l1.01-3.7-15.709-2.815-6.038 3.802-6.526 16.537z"
      ></path>
      <path
        fill="#0A0B1F"
        d="M313.592 162.228s-6.901-19.737 1.861-23.562c7.423-3.246 34.141-19.942 34.436 0 0 0 9.057 5.743 5.13 14.505 0 0 .806 6.038-3.121 9.057 0 0 .102-16.968-10.476-16.639-10.567.329-17.854.931-27.83 16.639z"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M352.374 164.419s3.053-1.43 4.313 1.736c1.26 3.167-2.236 5.562-4.79 5.914M313.784 164.26s-3.405-1.169-4.517 2.1c-1.112 3.268 2.86 5.357 5.641 5.493"
      ></path>
      <path
        fill="#fff"
        stroke="#28282D"
        strokeMiterlimit="10"
        d="M314.17 162.228s-.42 27.944 13.461 29.703c4.007.511 13.677 1.113 17.718-1.487 2.985-1.906 5.936-4.052 7.252-31.439 1.317-27.388-38.033-15.504-38.431 3.223z"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M333.408 161.615s1.385 9.591-.976 12.145c-.147.159-.181.386-.057.556.432.624 1.578 1.884 3.428 1.192M332.296 181.386s2.667 3.655 8.546-1.305"
      ></path>
      <path
        fill="#0A0B1F"
        d="M324.589 165.916a1.414 1.414 0 01-1.407-1.407c0-.772.635-1.407 1.407-1.407s1.407.635 1.407 1.407-.635 1.407-1.407 1.407zM342.25 165.916a1.414 1.414 0 01-1.407-1.407c0-.772.635-1.407 1.407-1.407s1.408.635 1.408 1.407-.636 1.407-1.408 1.407z"
      ></path>
      <path
        fill="#fff"
        d="M390.124 145.589H288.133v79.654h101.991v-79.654z"
        opacity="0.6"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M390.124 222.405v2.838h-2.838"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeDasharray="4.99 4.99"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M381.623 225.243h-87.826"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M290.97 225.243h-2.837v-2.838"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeDasharray="5.01 5.01"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M288.133 216.72v-65.445"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M288.133 148.426v-2.837h2.837"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeDasharray="4.99 4.99"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M296.634 145.589h87.815"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M387.286 145.589h2.838v2.837"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeDasharray="5.01 5.01"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M390.124 154.112v65.444"
      ></path>
      <path
        fill="#fff"
        stroke="#28282D"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M404.199 243.403s-5.097 8.592-22.712 8.399c-1.01-.012-1.895-.783-2.395-1.669-.874-1.532-.408-3.28.681-3.666 4.983-1.782 3.564-.93 4.994-1.918 1.43-.987-11.202 3.939-14.13-.204-2.974-4.2 2.701-5.868 3.927-6.05 1.657-.238 2.871-.703 12.689-.953 0 0-28.67 4.256-34.164-2.633-4.755-5.97 4.177-6.583 6.754-6.947.386-.056.76-.068 1.146-.045 3.11.204 24.107-.182 28.057-1.271 0 0 2.066-.397 1.635-2.032-.432-1.634-2.077-12.144 4.313-18.557 4.63-4.654 8.978 3.36 6.878 7.979-.954 2.088-1.362 4.654-1.532 6.401-.114 1.181.056 2.35.544 3.428 1.839 4.211 8.093 14.494 3.315 19.738z"
      ></path>
      <path
        fill="#28282D"
        d="M248.794 143.353s4.404 16.049 17.729 19.227c13.336 3.178 13.722 10.93 13.722 10.93s6.345-4.665-12.122-25.413c-15.254-17.127-19.329-4.744-19.329-4.744z"
      ></path>
      <path
        fill="#fff"
        stroke="#28282D"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M278.452 162.557s5.539-1.827 10.192 4.551c4.665 6.379 8.183 5.834 9.897 1.204 1.725-4.631-.658-10.862-14.312-16.208 0 0-.386-1.521 4.415-2.282 4.812-.76 24.993-7.502 25.447-11.247 0 0 3.144-4.983-2.452-8.229a2.964 2.964 0 00-1.453-.363c-.783 0-1.929.068-2.485.431-.886.579-19.046 11.055-25.878 12.462 0 0 11.509-3.768 14.743-7.037 3.224-3.269-.896-6.322-3.961-6.798-3.064-.477-10.998 6.14-10.998 6.14l5.981-4.642s.5-6.186-9.046-2.792c-9.545 3.393-11.951 7.162-15.197 9.579-3.36 2.508-9.443 10.124-5.391 16.242 4.71 7.116 9.034 7.945 9.034 7.945 2.951-.023 10.329 1.248 11.464 1.044z"
      ></path>
      <path
        fill="#fff"
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M322.024 191.238l-1.215 1.51h-1.657l-7.093 8.16 6.946 34.89 14.653-20.396v-1.884l-11.634-22.28zM346.257 191.238l1.305 1.51h1.793l7.696 8.16-7.525 34.89-15.868-20.396v-1.884l12.599-22.28z"
      ></path>
      <path
        fill="#fff"
        d="M316.191 325.202H159.356c-7.491 0-13.62-6.129-13.62-13.62v-27.138c0-7.491 6.129-13.62 13.62-13.62h156.835c7.491 0 13.62 6.129 13.62 13.62v27.138c0 7.491-6.129 13.62-13.62 13.62z"
      ></path>
      <path
        stroke="#5673FF"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M312.785 327.473H155.951c-7.491 0-13.62-6.129-13.62-13.62v-27.138c0-7.491 6.129-13.62 13.62-13.62h156.834c7.491 0 13.62 6.129 13.62 13.62v27.138c0 7.491-6.129 13.62-13.62 13.62z"
      ></path>
      <path
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M199.818 292.333h31.519M238.852 292.333h48.668M199.818 305.953h50.837"
        opacity="0.45"
      ></path>
      <path
        fill="#5673FF"
        d="M184.156 312.127h-10.328a2.882 2.882 0 01-2.872-2.871v-10.329a2.882 2.882 0 012.872-2.871h10.328a2.882 2.882 0 012.872 2.871v10.329a2.882 2.882 0 01-2.872 2.871z"
        opacity="0.37"
      ></path>
      <path
        fill="#5673FF"
        d="M179.82 308.109h-12.723a2.882 2.882 0 01-2.871-2.872v-12.723a2.88 2.88 0 012.871-2.871h12.723a2.882 2.882 0 012.872 2.871v12.723a2.883 2.883 0 01-2.872 2.872zM148.82 215.984a2 2 0 012-2h29a2 2 0 012 2v21.478c0 3.257-1.323 6.373-3.666 8.634l-1.722 1.663c-6.199 5.984-16.024 5.984-22.224 0l-1.722-1.663a12.001 12.001 0 01-3.666-8.634v-21.478z"
      ></path>
      <g clipPath="url(#clip0_2490_29983)">
        <path
          fill="#fff"
          stroke="#000"
          d="M165.737 223.151v.5h1.417a.416.416 0 01.416.416v9.167a.417.417 0 01-.416.417h-14.667a.417.417 0 01-.417-.417v-9.167a.416.416 0 01.417-.416h1.417v-1.417a5.922 5.922 0 011.733-4.184 5.908 5.908 0 014.183-1.733 5.91 5.91 0 014.184 1.733 5.922 5.922 0 011.733 4.184v.917zm-1.333.5h.5v-1.417a5.083 5.083 0 00-10.167 0v1.417h9.667zm-3.9 3.166v-.5h-1.367v4.667h1.367v-4.167z"
        ></path>
      </g>
      <path
        stroke="#0A0B1F"
        strokeMiterlimit="10"
        strokeWidth="1.4"
        d="M142.82 209.984a2 2 0 012-2h29a2 2 0 012 2v21.478c0 3.257-1.323 6.373-3.666 8.634l-1.722 1.663c-6.199 5.984-16.024 5.984-22.224 0l-1.722-1.663a12.001 12.001 0 01-3.666-8.634v-21.478z"
      ></path>
      <defs>
        <clipPath id="clip0_2490_29983">
          <path
            fill="#fff"
            d="M0 0H22V22H0z"
            transform="translate(148.82 213.984)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
